
















































import 'reflect-metadata'
import { Vue, Component, Prop } from 'vue-property-decorator'
import TxLinkInput from '@/components/Transaction/UtxoTxLinkInput.vue'
import LockTime from '@/components/Transaction/UtxoLockTime.vue'
import Threshold from '@/components/Transaction/UtxoThreshold.vue'
import Addresses from '@/components/Transaction/UtxoAddresses.vue'
import Stake from '@/components/Transaction/UtxoStake.vue'
import Stakeable from '@/components/Transaction/UtxoStakeable.vue'
import Block from '@/components/Transaction/UtxoBlock.vue'
import NFTPayload from '@/components/Transaction/UtxoNFTPayload.vue'
import Credentials from '@/components/Transaction/UtxoCredentials.vue'
import Summary from '@/components/Transaction/UtxoSummary.vue'
import { backgroundColor } from '@/helper'

@Component({
    components: {
        TxLinkInput,
        LockTime,
        Threshold,
        Addresses,
        Stake,
        Stakeable,
        Block,
        NFTPayload,
        Credentials,
        Summary,
    },
})
export default class UtxoRowInput extends Vue {
    @Prop() utxo!: any
    @Prop() txtype!: string

    // Importing UTXO from Atomic DB to P
    get isPVMImport() {
        return this.txtype === 'pvm_import' ? true : false
    }

    // Importing UTXO from Atomic DB to X
    get isImport() {
        return this.txtype === 'import' ? true : false
    }

    // Importing UTXO from Atomic DB to C
    get isAtomicImport() {
        return this.txtype === 'atomic_import_tx' ? true : false
    }

    get background(): string {
        return backgroundColor(this.utxo.output.addresses[0].displayAddress)
    }
}
